export default __webpack_public_path__ + "static/DSC_0023-71d717b3e89c6a7a1d46345f7046a1f5.jpg";